import colors from '../../bootstrap/styles/colors';


export default {
    ...colors
};
